<template>
  <el-scrollbar class="x_scroll" style="height: 100%">
      <div class="header_btn clearfix">
        <el-button v-if="type!==1" type="primary" size="small" @click="handleAdd" class="">添加</el-button>
      </div>
      <template v-if="list.length">
        <el-descriptions   v-for="(item,index) in list" :key="item.id"  class="margin-top descriptions" :title="`治疗史${index+1}`" :column="1" direction="horizontal" border>
          <template slot="extra">
            <el-button v-if="type!==1" type="primary" @click="handleEdit(item)" size="small">编辑</el-button>
          </template>
          <el-descriptions-item label="服药情况">{{item.medication}}</el-descriptions-item>
          <el-descriptions-item label="治疗史">{{item.treatment}}</el-descriptions-item>
          <el-descriptions-item label="调理史" :span="2">
            {{item.nurseHealth}}
          </el-descriptions-item>
          <el-descriptions-item label="目前身体情况补充">
            {{item.currentPhysicalCondition}}
          </el-descriptions-item>
        </el-descriptions>
      </template>
      <el-empty v-else description="描述文字"></el-empty>
      <!-- 添加治疗史 -->
      <el-dialog
        title="添加治疗史"
        :visible.sync="dialogVisible"
        width="50%"
        :before-close="handleClose">
       <el-form label-width="120px" class="form" ref="form" :rules="rules" :model="form" label-position="right">
        <el-form-item label="服药情况:" :label-width="formLabelWidth" prop="medication">
          <el-input v-model="form.medication" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="治疗史:" :label-width="formLabelWidth" prop="treatment">
          <el-input v-model="form.treatment" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="调理史:" :label-width="formLabelWidth" prop="nurseHealth">
          <el-input v-model="form.nurseHealth" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="目前身体情况补充:" :label-width="formLabelWidth" prop="currentPhysicalCondition">
          <el-input v-model="form.currentPhysicalCondition" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-debounce="onSave">确认</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>
      </el-dialog>
  </el-scrollbar>
</template>

<script>
import {deepClone} from '@/utils/index'
import { memberTreatmentHistoryInsert } from '@/api/system/member'
export default {
  props: {
    type: {  // 1 为会员 2为建档
      default: 1,
      type: Number
    },
    memberId: {
      type: Number,
      default() {
        return null
      }
    },
    memberInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      form: {},
      dialogVisible: false,
      formLabelWidth: '100px',
      rules: {
        medication: [{required: true, message: '请输入', trigger: 'blur'}],
        treatment: [{required: true, message: '请输入', trigger: 'blur'}],
        nurseHealth: [{required: true, message: '请输入', trigger: 'blur'}],
        currentPhysicalCondition: [{required: true, message: '请输入', trigger: 'blur'}]
      }
    }
  },
  methods: {
    // 编辑治疗历史
    handleEdit(item) {
      this.form = deepClone(item)
      this.dialogVisible = true
    },
    // 
    onSave() {
      this.$refs['form'].validate((valid) => {
          if (valid) {
            // alert('submit!');
            const data = deepClone(this.form)
            data.memberId = this.memberInfo?.id
            data.memberName = this.memberInfo?.memberName
            memberTreatmentHistoryInsert(data).then(res => {
              this.$message.success('新增成功')
              this.dialogVisible = false
              this.$emit('success')
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    // 新增对话框
    handleAdd() {
      this.dialogVisible = true
      this.form = {
        medication:undefined,
        treatment:undefined,
        nurseHealth:undefined,
        currentPhysicalCondition:undefined
      }
    },
   handleClose() {
      console.log('into=====>');
      this.resetForm('form')
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.header_btn {
  // height: 30px;
  padding-bottom: 10px;
}
  .form ::v-deep .el-form-item__content {
    width: 300px;
  }
  .descriptions {
    margin-bottom: 16px;
  }
</style>